import { ThemeUICSSObject } from '@apia/theme';
import observations from './observations';
import entityData from './entityData';
import processData from './processData';
import documents from './documents';
import taskMonitor from './taskMonitor';
/* IMPORT HERE */

const tabs: ThemeUICSSObject = {
  observations,
  entityData,
  processData,
  documents,
  taskMonitor,
  /* PREPEND HERE */
};

export default tabs;
